export const transformFeatureRecord = ({
  feature,
  apiName
}) => {
  return {
    shortName: feature.shortName,
    name: feature.displayName,
    description: apiName ? feature.descriptions[apiName] : null,
    shortLimit: apiName ? feature.shortLimits[apiName] : null
  };
};
export const transformGrowthFeature = ({
  feature
}) => {
  return {
    shortName: feature.shortName,
    name: feature.displayName,
    description: feature.defaultDescription,
    shortLimit: null
  };
};
export const transformFeatureRecordWithDefaults = ({
  feature,
  productLevel
}) => {
  return {
    shortName: feature.shortName,
    name: feature.displayName,
    description: feature.description,
    shortLimit: productLevel ? feature.shortLimits[productLevel] : null
  };
};